export default __webpack_public_path__ + "static/media/buttons-back-white.6c43516a.svg";